import {IconSize, iconStrokeWidthBySize} from '../icon_types';

type AlertIconProps = {
  id?: string;
  className?: string;
  size: IconSize;
  color?: string;
};

const pathDsBySize = {
  '16': [
    'M6.86001 2.57334L1.21335 12C1.09693 12.2016 1.03533 12.4302 1.03467 12.663C1.03402 12.8958 1.09434 13.1248 1.20963 13.327C1.32492 13.5293 1.49116 13.6978 1.69182 13.8159C1.89247 13.934 2.12055 13.9974 2.35335 14H13.6467C13.8795 13.9974 14.1076 13.934 14.3082 13.8159C14.5089 13.6978 14.6751 13.5293 14.7904 13.327C14.9057 13.1248 14.966 12.8958 14.9654 12.663C14.9647 12.4302 14.9031 12.2016 14.7867 12L9.14001 2.57334C9.02117 2.37741 8.85383 2.21542 8.65414 2.10299C8.45446 1.99057 8.22917 1.93151 8.00001 1.93151C7.77086 1.93151 7.54557 1.99057 7.34588 2.10299C7.1462 2.21542 6.97886 2.37741 6.86001 2.57334V2.57334Z',
    'M8 6V8.66667',
    'M8 11.3333H8.00667',
  ],
  '24': [
    'M10.2898 3.86L1.81978 18C1.64514 18.3024 1.55274 18.6453 1.55177 18.9945C1.55079 19.3437 1.64127 19.6871 1.8142 19.9905C1.98714 20.2939 2.2365 20.5467 2.53748 20.7239C2.83847 20.901 3.18058 20.9962 3.52978 21H20.4698C20.819 20.9962 21.1611 20.901 21.4621 20.7239C21.7631 20.5467 22.0124 20.2939 22.1854 19.9905C22.3583 19.6871 22.4488 19.3437 22.4478 18.9945C22.4468 18.6453 22.3544 18.3024 22.1798 18L13.7098 3.86C13.5315 3.56611 13.2805 3.32312 12.981 3.15448C12.6814 2.98585 12.3435 2.89725 11.9998 2.89725C11.656 2.89725 11.3181 2.98585 11.0186 3.15448C10.7191 3.32312 10.468 3.56611 10.2898 3.86V3.86Z',
    'M12 9V13',
    'M12 17H12.01',
  ],
  '32': [
    'M13.72 5.14667L2.42669 24C2.19385 24.4032 2.07065 24.8604 2.06935 25.326C2.06804 25.7917 2.18868 26.2495 2.41926 26.654C2.64984 27.0586 2.98233 27.3957 3.38364 27.6318C3.78495 27.8679 4.24109 27.9949 4.70669 28H27.2934C27.759 27.9949 28.2151 27.8679 28.6164 27.6318C29.0177 27.3957 29.3502 27.0586 29.5808 26.654C29.8114 26.2495 29.932 25.7917 29.9307 25.326C29.9294 24.8604 29.8062 24.4032 29.5734 24L18.28 5.14667C18.0423 4.75481 17.7077 4.43082 17.3083 4.20598C16.9089 3.98113 16.4583 3.86301 16 3.86301C15.5417 3.86301 15.0911 3.98113 14.6918 4.20598C14.2924 4.43082 13.9577 4.75481 13.72 5.14667V5.14667Z',
    'M16 12V17.3333',
    'M16 22.6667H16.0133',
  ],
};

const AlertIcon = (props: AlertIconProps) => {
  const {id, className, size, color} = props;
  const paths = pathDsBySize[size];
  const colorOptions = color || 'currentColor' || '#1E1E20';

  return (
    <svg
      id={id}
      className={className}
      width={size}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      fill="none">
      {paths?.map((d, index) => (
        <path
          key={index}
          d={d}
          stroke={colorOptions}
          strokeWidth={iconStrokeWidthBySize[size]}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      ))}
    </svg>
  );
};

export default AlertIcon;
